<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="shareable-result">
  <div class="shareable-header">
    <div class="max-width-1200">
      <div class="pull-right quote m-l-md m-b-md">
        <p>
          &ldquo;Before I can tell my life what I want to do with it, I must listen to
          my life telling me who I am.&rdquo; <br /><i>-Parker Palmer</i>
        </p>
      </div>
      <br />
      <h1>myIPSAT</h1>
      <h3>IPSAT 2.0 Archetype Report</h3>
      <br />
      <h4>powered by</h4>
      &nbsp;&nbsp;
      <img src="/assets/images/nexleader_logo.svg" alt="nexleader logo" class="full-width-image" />
    </div>
  </div>
  <div class="shareable-about">
    <div class="max-width-1200">
      <div class="row nexleader-onboarding-reverse-row">
        <div class="col-sm-6 shareable-about-info">
          <h3>What is the IPSAT 2.0 Archetype Report?</h3>
          <p>
            The IPSAT 2.0 Archetype Report translates your Identity Profile into
            a lens for how you contribute, collaborate, and grow. It reveals your
            primary and overlay archetypes so you can lead more effectively from
            who you truly are.
          </p>
        </div>
        <div class="col-sm-6 text-center">
          <img src="/assets/images/logo.svg" alt="logo" class="m-b-sm" />
        </div>
      </div>
    </div>
  </div>
  <div class="shareable-results">
    <h3 class="text-center m-b-md">My Archetype</h3>
    <div class="max-width-1200">
      <div class="row" *ngIf="loadError">
        <div class="col-md-12 text-center">
          <p class="text-muted">This IPSAT 2.0 Archetype Report is not available.</p>
        </div>
      </div>

      <div *ngIf="archetypeReport && !loadError">
        <!-- Wheel + primary/overlay overview -->
        <div class="row m-b-lg">
          <div class="col-sm-5 text-center">
            <h5 class="font-bold text-muted text-center m-b-md">
              My Archetype is a lens, not a label.
            </h5>
            <app-archetype-wheel
              [primary]="archetypeReport.archetype.primary"
              [secondary]="archetypeReport.archetype.secondary || ''"
            ></app-archetype-wheel>
            <h5 class="font-bold text-muted text-center m-t-md">
              It brings clarity, not conformity.
            </h5>
          </div>
          <div class="col-sm-7">
            <h2 class="font-bold m-b-md">My Archetype Overview</h2>
            <p class="m-b-md text-lg">
              I am {{ startsWithVowel(archetypeReport.archetype.primary) ? 'an' : 'a' }}
              <strong>{{ archetypeReport.archetype.primary }}</strong>&#8212;{{ primaryContent?.report_overview }}
            </p>
            <p class="m-b-md text-lg" *ngIf="archetypeReport.archetype.secondary">
              My <strong>{{ archetypeReport.archetype.secondary }}</strong> overlay
              adds additional dimensions.
              {{ overlayContent?.report_overview }}
            </p>
            <p class="m-b-md text-lg" *ngIf="primaryContent?.core_contribution">
              <strong>Core contribution:</strong>
              {{ primaryContent?.core_contribution }}
            </p>
            <p class="m-b-md text-lg"
               *ngIf="archetypeReport.ipsatScore !== undefined && archetypeReport.stage?.name">
              <strong>Overall IPSAT Score:</strong> {{ archetypeReport.ipsatScore }} / 100
              &nbsp;&middot;&nbsp;
              <strong>Stage:</strong> {{ archetypeReport.stage?.name }}
            </p>
          </div>
        </div>

        <!-- Primary + Overlay panels (mirrors the report page layout) -->
        <div class="row m-b-lg">
          <div [class.col-md-6]="archetypeReport.archetype.secondary"
               [class.col-md-12]="!archetypeReport.archetype.secondary">
            <div class="shareable-card">
              <h3 class="text-center">Primary Archetype: {{ archetypeReport.archetype.primary }}</h3>
              <p class="text-muted font-italic" *ngIf="primaryContent?.chapter_subtitle">
                {{ primaryContent?.chapter_subtitle }}
              </p>
              <p>{{ primaryContent?.report_overview }}</p>
            </div>
          </div>
          <div class="col-md-6" *ngIf="archetypeReport.archetype.secondary">
            <div class="shareable-card">
              <h3 class="text-center">Overlay Archetype: {{ archetypeReport.archetype.secondary }}</h3>
              <p class="text-muted font-italic" *ngIf="overlayContent?.chapter_subtitle">
                {{ overlayContent?.chapter_subtitle }}
              </p>
              <p>{{ overlayContent?.report_overview }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center m-t-xl m-b-md shareable-footer">
        <h4 class="font-bold">Be who you are. Love what you do.</h4>
      </div>
      <div>
        <div class="pull-left">
          {{ user?.firstName }} {{ user?.lastName }}
          <span *ngIf="coach">
            coached by
            <a *ngIf="coach.coachingUrl" [href]="coach.coachingUrl">
              {{ coach.firstName }} {{ coach.lastName }}
            </a>
            <a *ngIf="!coach.coachingUrl" [href]="
                'mailto:' + coach.email + '?subject=I&#8217;m interested in the IPSAT'
              ">
              {{ coach.firstName }} {{ coach.lastName }}
            </a>.
          </span>
        </div>
        <div class="text-center">
          <a [routerLink]="['/s', archetypeReport?.surveyResult]"
             *ngIf="archetypeReport?.surveyResult">
            View IPSAT 1.0 Result
          </a>
        </div>
        <div class="pull-right">
          <a href="http://myipsat.com" target="_blank">myipsat.com</a>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>
